import { render, staticRenderFns } from "./ModalSelectModelPreviewBAF.vue?vue&type=template&id=18151ec1&"
import script from "./ModalSelectModelPreviewBAF.vue?vue&type=script&lang=js&"
export * from "./ModalSelectModelPreviewBAF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports